import { isMatch, Link, useMatches } from '@tanstack/react-router';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from '@tempo-io/sui-breadcrumb';
import { Fragment } from 'react';

export const HeaderBreadcrumbList = ({ children }: { children: React.ReactNode }) => (
  <BreadcrumbList className="text-xs">{children}</BreadcrumbList>
);

interface HeaderBreadcrumbsProps {
  customBreadcrumbs?: React.ReactNode;
}

export const HeaderBreadcrumbs = ({ customBreadcrumbs }: HeaderBreadcrumbsProps) => {
  const matches = useMatches();

  if (customBreadcrumbs) {
    return <>{customBreadcrumbs}</>;
  }

  if (matches.some((match) => match.status === 'pending')) {
    return null;
  }

  const matchesWithCrumbs = matches.filter((match) => isMatch(match, 'loaderData.crumb'));

  if (matchesWithCrumbs.length <= 1) {
    return null;
  }

  return (
    <Breadcrumb>
      <HeaderBreadcrumbList>
        {matchesWithCrumbs.map((match, index) => {
          const crumb = match.loaderData?.crumb;
          const isLast = index === matchesWithCrumbs.length - 1;

          return (
            <Fragment key={match.fullPath ?? index}>
              <BreadcrumbItem>
                {isLast ? (
                  <BreadcrumbLink>{crumb}</BreadcrumbLink>
                ) : (
                  <BreadcrumbLink asChild>
                    <Link to={match.fullPath?.replace(/\/$/, '') || '/'} params={match.params}>
                      {crumb}
                    </Link>
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
              {index + 1 < matchesWithCrumbs.length && <BreadcrumbSeparator />}
            </Fragment>
          );
        })}
      </HeaderBreadcrumbList>
    </Breadcrumb>
  );
};
